import { useEffect, useState } from "react";
import "../../styles/all.css";
import "../../styles/theme.css";
import "./side.css";
import { Link } from "react-router-dom";

function Sidebar() {
    const [theme,settheme]=useState('light');
    useEffect(()=>{

        document.body.className=theme
    },[theme])
  return (
    <>
      <nav className="navbar  fixed-top">
        <div className="container-fluid">
          <a className="navbar-brand" href="/"><i class="fa-solid fa-user" ></i>Admin Dashbaord</a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="offcanvas offcanvas-start"
            tabIndex={-1}
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
          >
            <div className="offcanvas-header ">
              <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                Navgation Bar
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>

            <div className="offcanvas-body">
              <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
    
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="/#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    <i class="fa-solid fa-gauge"></i>Dashboard
                  </a>

                  <ul className="dropdown-menu">
                    <li>                     <Link to="/crm" className="custom-link">CRM</Link>
</li>
<li>
                        <Link to="/analytics" className="custom-link">Analytics</Link>


</li>
                  </ul>
                </li>
                 <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="/#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    <i class="fa-solid fa-address-book"></i>Reports
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                      <Link to="/SalesReport" className="custom-link">Sales Report</Link>

                    </li>
                    <li>
                      <Link to="/LeadsReport" className="custom-link">Leads Report</Link>

                    </li>
                    <li>
                      <Link to="/ProjectReport" className="custom-link"> Project Report</Link>

                    </li>


                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="/#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                 <i class="fa-solid fa-paperclip"></i>Leads
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                    <Link to="/Leads" className="custom-link">Leads</Link>

                    </li>
                    <li>
                    <Link to="/LeadsCreate" className="custom-link">Leads Create</Link>

                    </li>

                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="/#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                 <i class="fa-solid fa-key"></i>AuthAction
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                                            <Link to="/Login" className="custom-link">Login</Link>


                    </li>
                    <li>
                                          <Link to="/Register" className="custom-link">Register</Link>


                    </li>
                   
                    <li>
                    <Link to="/Verify-Otp" className="custom-link">Verify-Otp</Link>

                    </li>
                    <li>
                    <Link to="/Maintenance" className="custom-link">Maintenance</Link>

                    </li>

                  </ul>
                </li>
                 <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="/#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                <i class="fa-brands fa-algolia"></i>Proposal
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                     <Link to="/Proposal" className="custom-link">Proposal</Link>

                    </li>
                    <li>
                    <Link to="/ProposalView" className="custom-link">Proposal View</Link>

                    </li>
                    <li>
                    <Link to="/ProposalCreate" className="custom-link">Proposal Create</Link>

                    </li>
                

                  </ul>
                </li>
                 <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="/#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                <i class="fa-solid fa-user"></i>Customers
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                                          <Link to="/Customers" className="custom-link">Customers</Link>

                    </li>
                    <li>
                    <Link to="/CustomersView" className="custom-link">Customers View</Link>

                    </li>
                    <li>
                    <Link to="/CustomersCreate" className="custom-link">Customers Create</Link>

                    </li>
                  </ul>
                </li>
                  <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="/#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
               <i class="fa-solid fa-suitcase"></i>Projects
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                                           <Link to="/Projects" className="custom-link">Projects</Link>


                    </li>
                    <li>
                    <Link to="/ProjectsCreate" className="custom-link">Projects Create</Link>

                    </li>
               
                  </ul>
                </li>
                 <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="/#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
              <i class="fa-solid fa-circle-info"></i>Help Center
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                    <Link to="/KnowledgeBase" className="custom-link">KnowledgeBase</Link>

                    </li>
                  </ul>
                </li>
          <li className="nav-item">
  <button
    className="nav-link btn btn-link d-flex align-items-center gap-2"
    onClick={() => settheme(theme === "dark" ? "light" : "dark")}
  >
    {theme === "dark" ? (
      <>
        <i className="fa-regular fa-sun"></i>
        <span>Light Mode</span>
      </>
    ) : (
      <>
        <i className="fa-solid fa-moon"></i>
        <span>Dark Mode</span>
      </>
    )}
  </button>
</li>

              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Sidebar;
